import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_TEMPLATE_MUTATION_KEY } from '../../queryKeys';
import { invalidateAllAutomationTemplatesQueries } from '../../queries/useAutomationTemplatesQuery';

export function useDeleteAutomationTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: void) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		mutationFn: ({ id, impersonationContext }: { id: string; impersonationContext?: Api.IImpersonationContext }) => {
			return userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(id)}`,
					impersonationContext,
				}),
				'DELETE',
				null
			);
		},
		onError,
		onSuccess: data => {
			invalidateAllAutomationTemplatesQueries();
			onSuccess?.(data);
		},
	});
}
